import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DoctorRegister.css';
import { API_BASE } from './Auth'; // Re-use API_BASE logic

export default function DoctorRegister() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        password: '',
        confirmPassword: '',
        specialty: '',
        phone: ''
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirmPassword) {
            alert(t('doctor_auth.passwords_mismatch'));
            return;
        }

        setLoading(true);
        try {
            const payload = {
                email: formData.email,
                password: formData.password,
                role: 'doctor',
                fullName: formData.fullName,
                specialty: formData.specialty,
                phone: formData.phone
            };

            const res = await fetch(`${API_BASE}/api/auth/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const json = await res.json();
            if (!res.ok) throw new Error(json.error || 'Registration failed');

            alert(t('doctor_auth.success_alert'));
            navigate('/login');
        } catch (err) {
            alert(err.message || t('doctor_auth.error_occurred'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="doc-auth-container">
            {/* Left Side: Value Proposition */}
            <div className="doc-auth-hero">
                <div className="doc-hero-content">
                    <h1 className="doc-hero-title">{t('doctor_auth.hero_title')}</h1>
                    <p className="doc-hero-subtitle">
                        {t('doctor_auth.hero_subtitle')}
                    </p>
                    <ul className="doc-hero-list">
                        <li>{t('doctor_auth.benefit_1')}</li>
                        <li>{t('doctor_auth.benefit_2')}</li>
                        <li>{t('doctor_auth.benefit_3')}</li>
                    </ul>
                </div>
            </div>

            {/* Right Side: Registration Form */}
            <div className="doc-auth-form-wrapper">
                <div className="doc-auth-card">
                    <div className="doc-form-header">
                        <h2 className="doc-form-title">{t('doctor_auth.form_title')}</h2>
                        <p className="doc-form-subtitle">{t('doctor_auth.form_subtitle')}</p>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="doc-field-group">
                            <label className="doc-label">{t('doctor_auth.full_name')}</label>
                            <input
                                className="doc-input"
                                name="fullName"
                                placeholder={t('doctor_auth.full_name_placeholder')}
                                required
                                onChange={handleChange}
                            />
                        </div>

                        <div className="doc-field-group">
                            <label className="doc-label">{t('doctor_auth.email')}</label>
                            <input
                                type="email"
                                className="doc-input"
                                name="email"
                                placeholder={t('doctor_auth.email_placeholder')}
                                required
                                onChange={handleChange}
                            />
                        </div>

                        <div className="doc-field-group">
                            <label className="doc-label">{t('doctor_auth.specialty')}</label>
                            <input
                                className="doc-input"
                                name="specialty"
                                placeholder={t('doctor_auth.specialty_placeholder')}
                                required
                                onChange={handleChange}
                            />
                        </div>

                        <div className="doc-field-group">
                            <label className="doc-label">{t('doctor_auth.phone')}</label>
                            <input
                                className="doc-input"
                                name="phone"
                                placeholder={t('doctor_auth.phone_placeholder')}
                                required
                                onChange={handleChange}
                            />
                        </div>

                        <div className="doc-field-group">
                            <label className="doc-label">{t('doctor_auth.password')}</label>
                            <input
                                type="password"
                                className="doc-input"
                                name="password"
                                placeholder={t('doctor_auth.password_placeholder')}
                                required
                                onChange={handleChange}
                            />
                        </div>

                        <div className="doc-field-group">
                            <label className="doc-label">{t('doctor_auth.confirm_password')}</label>
                            <input
                                type="password"
                                className="doc-input"
                                name="confirmPassword"
                                placeholder={t('doctor_auth.confirm_placeholder')}
                                required
                                onChange={handleChange}
                            />
                        </div>

                        <button type="submit" className="doc-btn-submit" disabled={loading}>
                            {loading ? t('doctor_auth.processing') : t('doctor_auth.submit_btn')}
                        </button>

                        <div className="doc-footer">
                            <p>{t('doctor_auth.already_member')} <Link to="/login" className="doc-link">{t('doctor_auth.login_link')}</Link></p>
                            <p style={{ marginTop: '0.5rem', fontSize: '0.8rem' }}>
                                {t('doctor_auth.not_doctor')} <Link to="/register" className="doc-link">{t('doctor_auth.patient_link')}</Link>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
